import React, { useState } from 'react';
import { Body2, Calendar, Time, H4, PrimaryButton, Icon, Button } from 'ensightful-koala-ui';
import styled, { css } from 'styled-components';

import { Modal } from 'components/molecules/Modal';
import { ButtonDropDown } from '../DropDown';

const SubtitleContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const BottomContainer = styled.div`
    margin-top: 16px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 32px;
`;

const ButtonContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
`;

const StyledModal = styled(Modal)`
    .ant-modal-content {
        width: 600px;
    }
`;

const StyledBody2 = styled(Body2)``;

const StyledPrimaryButton = styled(PrimaryButton)``;

const GroupSetSyncModal = ({ visible, groupSets = [], defaultValue, onSave, onCancel, getGroupSets, ...props }) => {
    const [selectedGroupSet, setSelectedGroupSet] = useState();

    const handleSave = () => {
        return onSave(selectedGroupSet);
    };

    return (
        <StyledModal visible={visible} onCancel={onCancel} closable={true} {...props}>
            <H4>Select a Group Set to Sync with Canvas</H4>
            <SubtitleContainer style={{ margin: '20px 0px 8px 0px' }}>
                <StyledBody2>Group Set</StyledBody2>
                <ButtonContainer>
                    <Icon kind={'resync'} fill={'#6347ff'} size={12} />
                    <Button
                        variant={'tertiary'}
                        onClick={() => getGroupSets()}
                        style={{ color: '#6347ff', padding: '0px 0px 0px 8px' }}
                    >
                        Resync List
                    </Button>
                </ButtonContainer>
            </SubtitleContainer>
            <ButtonDropDown
                width={'100%'}
                itemList={groupSets}
                value={selectedGroupSet || defaultValue}
                placeholder={'Select a group set'}
                bordered={true}
                onChange={(value) => setSelectedGroupSet(value)}
            />
            <BottomContainer>
                <Button variant={'tertiary'} onClick={onCancel}>
                    Cancel
                </Button>
                <StyledPrimaryButton active text={'Sync with Canvas'} onClick={() => handleSave()} />
            </BottomContainer>
        </StyledModal>
    );
};

export default GroupSetSyncModal;
